<template>
  <div v-if="loaded">
    <div id="game">
      <transition name="fade" mode="out-in" appear>
        <p id="headtext" v-html="text" :key="text"></p>
      </transition>

      <result id="result" :isResult="isResult" :results="results" :bonsData="bonsData"></result>
      
      <!-- SVG -->
      <maschine :active="maschineActive" :combination="combinator.currentCombination"></maschine>
      <div id="svgcontainer"></div>
      <div id="svgHoverLeft"></div>
      <div id="svgHoverRight"></div>

      <dots id="dots" :combination="combinator.currentCombination" :isVisible="combinator && dotsVisible"></dots>

      <!-- BUTTON SECTION -->
      <section id="bottom">
        <p id="successText" v-html="successText"></p>
        <transition name="fade" mode="out-in" appear>
          <img v-if="!isTestRun && !isGameRunning && !isResult" :key="isTestRun" :src="keysImg"/>
       </transition>
      </section>

      <!-- PROGRESS CONTAINER -->
      <transition name="fade" mode="out-in" appear>
        <div id="progressContainer" v-if="isGameRunning" :key="isGameRunning">
          <p>{{this.combinator.successCounter}}</p>
          <div id="timebar">
            <div id="timebarinner"></div>
          </div>
        </div>
      </transition>

      <!-- ANSEHEN -->
      <transition name="fade" mode="out-in" appear>
        <div :key="isTestRun" id="buttons">
          <button class="play" v-on:click="testRun(level < 2 ? 3 : 1)" v-if="!isTestRun && !isGameRunning && !isResult" v-bind:class="{'inactive' : dotsVisible}">Ansehen</button> 
        </div>
      </transition>

      <!-- NOCHMAL & SPIELEN -->
      <transition name="fade" mode="out-in" appear>
        <div :key="isTestRun" id="buttons">
          <button class="again" v-on:click="repeatTestRun(level < 2 ? 3 : 1)" v-if="isTestRun && (!isGameRunning || !isResult)" v-bind:class="{'inactive' : !buttonActiveA}">Nochmal</button>
          <button class="play" v-on:click="startGame()" v-if="isTestRun && (!isGameRunning || !isResult)" v-bind:class="{'inactive' : !buttonActiveB}">Spielen</button> 
        </div>
      </transition>

      <transition name="fade" mode="out-in" appear>
        <div :key="isResult" id="buttons">
          <button v-if="isResult" v-on:click="nextLevel()">Weiter</button>
        </div>
      </transition>
    </div>    
  </div>   
</template>

<script>
import axios from "axios";
import Velocity from "velocity-animate";

import Combinator from "./Combinator";
import Maschine from "./Maschine";
import Dots from "./Dots";
import Result from "./Result";
import Bonbon from "./Bonbon";

import eventBus from "../eventBus";

window.combinators = [];

export default {
  name: "game",
  data() {
    return {
      loaded: false,
      level: 1,
      combinator: "",
      bonName: "Undefined",
      dotsVisible: false,
      isTestRun: false,
      buttonActiveA: false,
      buttonActiveB: false,
      text: "",
      successText: "",
      isGameRunning: false,
      isResult: false,
      bonsData: [],
      bonFailData: "",
      isEnd: false,
      results: [],
      repeatCount: 0,
      maschineActive: false,
      keysImg: '',
      audios: []
    };
  },
  components: {
    dots: Dots,
    result: Result,
    maschine: Maschine
  },
  watch: {
    combinator: function(val) {
      var last = window.combinators.length - 1;
      this.bonName = last >= 0 ? window.bonNames[last] : "";
    }
  },
  created() {
    this.level = this.$route.params.level || 1;
    this.repeatCount = 0;
    this.keysImg = window.dataPath + "image/keys.svg";

    let callback = () => {
      var pre = window.dataPath + "audio/intro/";
      this.audios.push(new Audio(pre + 'Annika_Honnef-Einfuehrung_C.mp3'));
      this.audios.push(new Audio(pre + 'Annika_Honnef-Uebungsphase_Fertig.mp3'));
      this.audios.push(new Audio(pre + 'Annika_Honnef-Reihenfolg_B_Uebergang.mp3'));
      this.audios.push(new Audio(pre + 'Annika_Honnef-Durchgang_B_Auswertung.mp3'));
      this.audios.push(new Audio(pre + 'Annika_Honnef-Durchgang_B_Auswertung_2.mp3'));
      this.audios.push(new Audio(pre + 'Annika_Honnef-Zusammenfassung.mp3'));

      setTimeout(() => {
        this.init();
      }, 500);
    }

    this.fetchData(() => (this.loaded = true));
    this.loadBonbonData(callback);

    document.addEventListener("keyup", this.keyUp);
  },
  beforeDestroy() {
    this.stopAllAudios();
    document.removeEventListener("keyup", this.keyUp);
  },
  methods: {
    fetchData(callback) {
      if (callback) callback();
    },
    init() {
      this.stopAllAudios();
      window.combinators = [];
      window.combinators.push(this.createCombinator());

      // Redirect if Level 2 is only reached by url manipulation.
      if (window.combinators.length < this.level) {
        this.$nextTick(() => this.$router.replace({ path : "/Game/1" }));
      }

      this.combinator = window.combinators[window.combinators.length - 1];

      eventBus.$emit('reset');

      this.$nextTick(() => {
        this.text = this.initText();
        this.stopAllAudios();
        this.playAudio(0);
      });
    },
    testRun(numRepeats) {
      if (this.isTestRun) return;
      this.isTestRun = true;
      eventBus.$emit("hideResult");
      this.stopAllAudios();

      numRepeats = numRepeats ? numRepeats : 3;
      
      this.combinator.active = false;
      this.combinator.reset();

      var highlightStepDuration = 1500;

      if (this.level > 1) {
        // No Repeats - only show Combination.
        this.text = this.testRunText();
        setTimeout(() => this.showCombination(highlightStepDuration), 500);

        this.repeatCount++;

        setTimeout(() => {
          
          this.combinator.reset();
          this.disableCombinators();

          eventBus.$emit("cleanColors");

          this.dotsVisible = false;

          if (this.repeatCount < 3) {
            this.buttonActiveA = true;
          }
          this.buttonActiveB = true;

        }, this.combinator.currentCombination.length * highlightStepDuration + 4000);

      } else { 
        eventBus.$emit("cleanColors");
        this.maschineActive = false;

        this.text = this.testRunText();

        
        setTimeout(() => this.showCombination(highlightStepDuration), 500);


        var numRepeatsTextParts = ["", "ein mal", "zwei mal", "drei mal", "vier mal"];
        setTimeout(() => {
          eventBus.$emit("cleanColors");
          this.dotsVisible = false;
          this.text = "Jetzt bist Du dran!<br>Gib die Tastenkombination " + numRepeatsTextParts[numRepeats] + " hintereinander korrekt ein.";
          this.successText
          this.combinator.active = true;
          this.maschineActive = true;

          this.combinator.succcessStepCallback = this.successStep;
          this.combinator.successCallback = () => {
            this.showBonbon(true);

            if (this.combinator.successCounter >= numRepeats) {
              this.combinator.reset();
              this.disableCombinators();
              
              this.maschineActive = false;

              this.buttonActiveA = true;
              this.buttonActiveB = true;

              this.successText = "Super! Ein " + this.bonName.substr(0, this.bonName.length - 1) + "!";
              this.animatesuccessTextText();
              this.playAudio(1);

              this.text = this.testRunSuccessText();
            } else {
              eventBus.$emit("cleanColors");
              this.successText =  "Richtig! Wiederhole die Reihenfolge noch " + numRepeatsTextParts[numRepeats - this.combinator.successCounter] + "!!";
              this.animatesuccessTextText();
            }
          };
          
          this.combinator.failCallback = () => {
            this.showBonbon(false);

            this.combinator.reset();
            this.combinator.failCallback = null;
            this.combinator.successCallback = null;
            this.combinator.active = false;

            eventBus.$emit("cleanColors");
            this.maschineActive = false;

            this.buttonActiveA = true;
            this.buttonActiveB = false;

            this.text = this.testRunFailText();

            this.timeoutId = setTimeout(this.repeatTestRun, 3000); 
          };
        }, this.combinator.currentCombination.length * highlightStepDuration + 3000);
      }
    },
    repeatTestRun() {
      this.timeoutId ? clearTimeout(this.timeoutId) : {};
      if (this.repeatCount >= 3) return;
      if (this.buttonActiveA) {
        this.buttonActiveA = false;
        this.buttonActiveB = false;
        this.isTestRun = false;
        this.testRun();
      }
    },
    startGame() {
      if (this.buttonActiveB) {
        this.stopAllAudios();
        this.buttonActiveB = false;
        this.isTestRun = false;
        this.isGameRunning = true;

        eventBus.$emit("cleanColors", 100);
        this.maschineActive = true;

        this.text = "Produziere in <span>" + window.gameTime + " Sekunden</span> so viele <span>" + this.bonName + "</span> wie möglich!";

        setTimeout(() => {

          // TODO REMOVE - window.combinators should be empty
          for (var i = 0; i < combinators.length; i++) {
            combinators[i].reset();
            combinators[i].active = true;
          }

          var timebarDom = document.getElementById("timebarinner");
          Velocity(
            timebarDom,
            { width: "0%" },
            { duration: window.gameTime * 1000, complete: this.gameComplete }
          );

          this.combinator.succcessStepCallback = this.successStep;

          this.combinator.successCallback = () => {
            this.showBonbon(true);
            this.successText = "Super! Ein " + this.bonName.substr(0, this.bonName.length - 1) + "!";
            this.animatesuccessTextText();;
            eventBus.$emit("cleanColors");
          };
          
          this.combinator.failCallback = () => {
            if (this.combinator.failCounter % 5 == 0) {
              this.showBonbon(false);
              this.successText = "Ohh - Du hast Ausschuss produziert!";
              this.animatesuccessTextText();
            }
            eventBus.$emit("cleanColors");
          };
        }, 1000);
      }
    },
    gameComplete() {
      this.isGameRunning = false;
      this.isResult = true;

      this.maschineActive = false;
      eventBus.$emit("cleanColors");

      var fails = Math.floor(this.combinator.failCounter / 5);
      var success = this.combinator.successCounter;

      if (window.combinators.length <= 1) {
        this.results.push(Array(success, fails));
      } else {
        var last = window.combinators[window.combinators.length - 2].successCounter;
        this.results.push(Array(success, last, fails));
      }

      var failsTextParts = ["keinen", "ein mal", "zwei mal", "drei mal", "vier mal"];
      var failsText = (fails < failsTextParts.length ? failsTextParts[fails] : fails + " mal ") + " Ausschuss";

      let winsText = (bonName, wins) => {
        var winsTextParts = ["keine", "ein", "zwei", "drei", "vier"];
        var text = (wins < winsTextParts.length ? winsTextParts[wins] : "" + wins) + " " + bonName;
        text = wins == 1 ? winsTextParts[wins] + " " + bonName.substr(0, bonName.length - 1) : text;
        return text;
      };

      var otherText = () => {
        var text = "";
        for (var i = 0; i < window.combinators.length - 1; i++) {
          text += i < window.combinators.length - 2 ? ", " : " und ";
          text += winsText(window.bonNames[i], window.combinators[i].successCounter );
        }
        return text;
      };

      var spacer = window.combinators.length > 1 ? ", " : " und ";

      this.text =
        "Super! Du hast " + winsText(window.bonNames[window.combinators.length - 1], success) +
        spacer + failsText + otherText() + " in " + window.gameTime + " Sekunden produziert!<br/>" +
        (window.combinators.length < window.iterationDepth
          ? "Ein neuer Auftrag ist eingegangen – bearbeite ihn bitte jetzt und drück auf <span>Weiter.</span>"
          : "<br/>" +
            "Hast Du einen Unterschied zwischen den beiden Produktionsrunden gemerkt?<br/>" +
            "Eventuell ist dir die Produktion in der zweiten Runde schwerer " +
            "gefallen als in der ersten. Woran liegt das?!<br/><br/>" +
            "Um zu erfahren warum, klicke auf Weiter.");
      this.stopAllAudios();
      window.combinators.length < window.iterationDepth ? this.playAudio(3) : this.playAudio(4);

      var successes = [];

      for (var i = 0; i < window.combinators.length; i++) {
        successes.push(window.combinators[i].successCounter);
        window.combinators[i].reset();
      }

      eventBus.$emit("showResult", this.level > 1 ? 1400 : 1200);

      this.disableCombinators();
    },
    nextLevel() {
      if (window.combinators.length < window.iterationDepth) {
        window.combinators.push(this.createCombinator());
        this.combinator = window.combinators[window.combinators.length - 1];

        this.level++;
        this.maschineActive = false;
        this.text = this.nextLevelText();
        this.stopAllAudios();
        this.playAudio(2);
        this.isResult = false;
        eventBus.$emit('hide');

        var newPath = this.$route.path.substr(0, this.$route.path.lastIndexOf("/")) + "/" + this.level;
        this.$router.replace({ path: newPath });
      } else {
        this.end();
      }
    },
    end() {
      if (this.isEnd) {
        this.isEnd = false;
        this.showVideo();
      } else {
        this.isEnd = true;
        this.text = this.endText();
        this.stopAllAudios();
        this.playAudio(5);
        eventBus.$emit("hideRobot");
        eventBus.$emit('hide');
      }
    },
    showVideo() {
      this.$nextTick(() => this.$router.replace({ path : "/Intro/1" }));
    },
    /**
     * Der erste Versuch eine (neue) Kombination einzugeben.
     *
     * @param {*} numRepeats Die Anzahl der Wiederholungen die der User eingeben muss bis er spielen darf.
     */
    showBonbon(success) {
      if (success) {
        var bonbon = new Bonbon(
          this.bonsData[window.combinators.length - 1][0],
          this.bonsData[window.combinators.length - 1][1],
          null,
          this.combinator.currentCombination,
          window.colors
        );
        bonbon.show(true);
      } else {
        var bonbon = new Bonbon(
          "fail",
          this.bonFailData,
          null,
          this.combinator.currentCombination,
          window.colors
        );
        bonbon.show(true);
      }
    },
    /**
     * Disable all Combinators.
     */
    disableCombinators() {
      for (var i = 0; i < window.combinators.length; i++) {
        window.combinators[i].active = false;
        window.combinators[i].successCallback = null;
        window.combinators[i].succcessStepCallback = null;
        window.combinators[i].failCallback = null;
      }
    },
    animatesuccessTextText() {
      var dom = document.getElementById("successText");
      Velocity(dom, "stop");
      Velocity(dom, { opacity: 1 }, { duration: 0 });
      Velocity(
        dom,
        { opacity: 0 },
        { duration: 1000, easing: "easeInQuint", queue: false }
      );
    },
    showCombination(duration) {
      this.dotsVisible = true;
      eventBus.$emit("highlight", duration);
    },
    successStep(step, combination) {
      var index = parseInt(combination[step]) - 1;
      var color = window.colors[index];
      eventBus.$emit("successStep", step, color);
    },
    close() {
      this.clearData();
      this.$nextTick(() => {
        let path = this.$route.path;
        this.$router.replace({
          path: path.substr(0, path.lastIndexOf("/")) || "/"
        });
      });
    },
    clearData() {
      /**
       * used to trigger out transition
       * */
      this.dotsVisible = false;
    },
    initText() {
      return (
        "Und schon geht‘s los: Für eine Bestellung von einem Kunden sollen heute in der Fabrik<br/>" +
        "<span>" + this.bonName + "</span> produziert werden. Bist du bereit dir die Reihenfolge anzusehen?<br/>" +
        "Dann klicke jetzt auf Ansehen."
      );
    },
    testRunText() {
      var combination = [];
      var combinationStr = this.combinator.currentCombination.join(", ");
      return "Sieh dir die Reihenfolge genau an!<br>" +
        "Es sollen <span>" + this.bonName + "</span> produziert werden.<br/>" +
        "Die Reihenfolge dafür ist <span>" + combinationStr + ".</span>";
    },
    testRunFailText() {
      return "Du hast Ausschuss hergestellt. Die Reihenfolge der Tasten war nicht korrekt.<br>" +
        "Möchtest du es noch einmal probieren? Dann klicke auf Nochmal.";
    },
    testRunSuccessText() {
      return "Super! Du hast es drauf! Richtig! Bist du bereit für das Spiel?<br/>" +
        "Du hast nun " + window.gameTime + " Sekunden Zeit – produziere so viele " +
        this.bonName + " wie möglich.<br/>" + "Los geht’s! Klicke jetzt auf Spielen.";
    },
    nextLevelText() {
      return (
        "Für eine neue Bestellung sollen jetzt <span>" + window.bonNames[window.combinators.length - 1] +
        "</span> produziert werden.<br/><br/>" +
        "Damit <span>" + window.bonNames[window.combinators.length - 1] +
        "</span> produziert werden, ändert sich die Bedienung der " +
        "Tasten. Weil die Lieferung schnell an den Kunden gehen muss, kannst du dir " +
        "die geänderte Reihenfolge jetzt nur ansehen. Danach startet direkt die Produktion, " +
        "ohne dass du die Reihenfolge noch einmal üben kannst.<br/><br/>" +
        "<span>Achtung</span>: nachdem Du die geänderte Reihenfolge gesehen hast, geht die Produktion sofort los.<br/><br/>" +
        "Wenn du die Tasten in der geänderten Reihenfolge eingibst, produziert die " +
        "Maschine <span>" + window.bonNames[window.combinators.length - 1] + "</span>." +
        " Wenn du eine falsche Reihenfolge eingibst,<br/>" +
        "produziert die Maschine Ausschuss. Wenn du die alte Reihenfolge eingibst, " +
        "produzierst du versehentlich wieder <span>" + this.bonName + "</span>" + 
        " – das ist nicht die Aufgabe.<br/><br/>" +
        "Bist du bereit dir die Reihenfolge anzusehen? Dann klicke jetzt auf Ansehen."
      );
    },
    endText() {
      return (
        "Da du dir die erste Reihenfolge der Tasten gut gemerkt hattest ist es dir<br/>" +
        "vielleicht schwerer gefallen, die geänderte Reihenfolge anzuwenden. " +
        "Du hast vielleicht sogar versehentlich Pfefferminzbonbons statt Karamellbonbons produziert.<br/><br/>" +
        "Um geänderte Arbeitsprozesse ausführen zu können, müssen zuerst zuvor erlernte Prozesse, " +
        "die nicht mehr benötigt werden, vergessen werden. Dies gelingt durch einen Prozess der sich „willentliches Vergessen“ nennt.<br/><br/>" +
        "Hier ist Vergessen nicht schlecht, sondern notwendig.<br/><br/>" +
        "Sieh dir den Film an um mehr über willentliches Vergessen zu lernen und warum der Prozess des willentlichen Vergessens sehr wichtig ist."
      );
    },
    /**
     * Laden der Bonbon-Daten.
     */
    loadBonbonData(callback) {
      this.bonsData = [];
      var pre = window.dataPath + "image/bonbons/";

      for (var i = 0; i < window.numDifferentBons; i++) {
        var bonPath = pre + (i + 1) + ".svg";
        axios.get(bonPath).then(response => {
          this.bonsData.push([this.bonsData.length + 1, response.data]);
          this.bonsData = this.shuffleArray(this.bonsData);
          if (this.bonsData.length >= window.numDifferentBons) callback();
        }).catch(error => console.log(error));
      }

      var bonbonPathFail = pre + "fail.svg";
      axios.get(bonbonPathFail).then(response => {
        this.bonFailData = response.data;
      }).catch(error => console.log(error));
    },
    /**
     * Key-Up-Event on HTML-Body.
     */
    keyUp(e) {
      e.preventDefault();
      var currentKey = e.key;
      window.combinators.forEach(combinator => {
        combinator.keyDown(currentKey);
        console.log('---------------');
      });
    },
    /**
     * Erstellen einer einzigartigen Kombinationen.
     */
    createCombinator() {
      var arr = new Array(1, 2, 3, 4, 5, 6, 7, 8);
      var newCombination = [];
      if (window.combinators.length <= 0) {
        var keys = this.shuffleArray(arr);
        newCombination = keys.slice(0, Math.min(window.combinationLength, keys.length));
      } else {
        newCombination = window.combinators[0].currentCombination.slice();
        var leftOvers = arr.filter(i => newCombination.indexOf(i) < 0);
        leftOvers = this.shuffleArray(leftOvers);
        if (newCombination.length >= 2) {
          newCombination[1] = leftOvers[0];
          if (newCombination.length >= 5) {
            newCombination[4] = leftOvers[1];
          }
        }
      }

      return new Combinator(window.keys, newCombination, audios);
    },
    stopAllAudios() {
      for (let index = 0; index < this.audios.length; index++) {
        const audio = this.audios[index];
        audio.pause();
        audio.currentTime = 0;
      }
    },
    playAudio(index) {
      var audio = this.audios[index];
      audio.volume = window.volume;
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
        var playPromise = audio.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {}).catch(error => {});
        }
      }
    },
    /**
     * Randomize array element order in-place.
     * Using Durstenfeld shuffle algorithm.
     */
    shuffleArray(array) {
      var newArray = array.slice();
      for (var i = newArray.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = newArray[i];
        newArray[i] = newArray[j];
        newArray[j] = temp;
      }
      return newArray;
    },
    /**
     * Vergleicht zwei Array ob die inhaltlich Identisch sind.
     *
     * @param {*} a
     * @param {*} b
     */
    arraysEqual(a, b) {
      if (a === b) return true;
      if (a == null || b == null) return false;
      if (a.length != b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
      }
      return true;
    }
  }
};
</script>



<style lang="scss">
@import "../style/animate.css";
@import "../style/transitions.scss";
@import "../style/basic.scss";

#game {
  width: 100%;
  height: 100%;
  margin-left: 0%;

  p#headtext {
    padding-top: 25px;
    padding-left: 10%;
    width: 80%;
    padding-right: 10%;
    font-size: 24px;
    min-height: 100px;
    position: absolute;
    top: 0;
    background: linear-gradient(
      to bottom,
      $grey 0%,
      rgba(255, 255, 255, 0) 100%
    );

    span {
      font-family: 'DINPro-Bold', sans-serif;
      font-size: 24px;
    }
  }


  #svgcontainer {
    height: calc(100% - 150px);
    min-height: calc(100% - 150px);
    margin-top: 150pfx;
    overflow: hidden;
    width: auto;
    opacity: 0;

  /*
    svg {
      height: calc(100% - 150px);
      overflow: hidden;
      opacity: 0;
    }
    */
  }


  #svgHoverRight, #svgHoverLeft {
    position: absolute;
    width: 50px;
    height: 100%;
    z-index: 6;
    top: 0;
    right: -1px;
    background: linear-gradient(
      to left,
      $grey 0%,
     rgba(102, 101, 101, 0) 100%
    );
  }

  #svgHoverLeft {
    left: -1px;
    background: linear-gradient(
      to right,
      $grey 0%,
     rgba(102, 101, 101, 0) 100%
    );
  }

  #bottom {
    margin-top: 0px;
    margin-left: 0%;
    width: 100%;
    font-size: 24px;
    background: $grey;
    position: absolute;
    bottom: 0;
    min-height: 175px;

    &:before {
      position: absolute;
      content: " ";
      width: 100%;
      height: 150px;
      min-height: 150px;
      top: -150px;
      background: linear-gradient(
        to top,
        $grey 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }

    p#successText {
      margin-left: 10%;
      font-size: 24px;
      font-family: 'DINPro-Bold', sans-serif;
    }

    img {
      position: absolute;
      width: 435px;
      left: calc(50% - (435px / 2));
      bottom: 140px;
    }
  }

  #buttons {
    position: absolute;
    z-index: 3;
    float: left;
    margin-left: 50%;
    margin-top: 9%;
    transform: translate(-50%, 0%);
    bottom: 50px;

    button {
      position: relative;

      &:not(:first-of-type) {
        margin-left: 25px;
      }
    }
  }
  #progressContainer {
    position: absolute;
    z-index: 1;
    float: left;
    padding-left: 10%;
    padding-right: 10%;
    width: 100%;
    height: 150px;
    font-size: 24px;
    padding-top: 2.5%;
    box-sizing: border-box;
    bottom: 50px;

    p {
      margin: 0;
      padding: 0;
      width: 100%;
      float: right;
      height: 75px;
      line-height: 31px;
      font-size: 24px;
      text-align: right;
    }

    #timebar {
      float: left;
      box-sizing: border-box;
      border: 7px solid white;
      width: 100%;
      height: 47px;

      #timebarinner {
        float: left;
        height: 100%;
        width: 100%;
        background-color: white;
      }
    }
  }

  #message {
    opacity: 0;
  }
}

#kasten1Schaufelrad {
  transform-origin:498.048px 237.968px;
}
</style>



// WEBPACK FOOTER //
// src/components/Game.vue